// extracted by mini-css-extract-plugin
export default {"headerTwo":"chYcYU","headerThree":"XzJNy6"};